import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';

import { SubTabsType } from '../ThemeWidget';
import { DRAWER_THEME_ID } from './ThemeDrawer';

export const useThemeDrawer = () => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const themeId = params[queryKeys.themeId];
  const isDrawerOpen = params[queryKeys.activeDrawer] === DRAWER_THEME_ID;

  const openDrawer = (themeId: string) =>
    setQueryParams({
      [queryKeys.activeDrawer]: DRAWER_THEME_ID,
      [queryKeys.activeDrawerTab]: SubTabsType.ThemeExposure,
      [queryKeys.themeId]: themeId,
    });

  const closeDrawer = () =>
    deleteQueryParam([
      queryKeys.activeDrawer,
      queryKeys.activeDrawerTab,
      queryKeys.themeId,
      queryKeys.competitorTag,
    ]);

  return {
    closeDrawer,
    openDrawer,
    isDrawerOpen,
    themeId,
  };
};
